import { render, staticRenderFns } from "./manual_rating_judge.vue?vue&type=template&id=18633864&scoped=true"
import script from "./manual_rating_judge.vue?vue&type=script&lang=js"
export * from "./manual_rating_judge.vue?vue&type=script&lang=js"
import style0 from "./manual_rating_judge.vue?vue&type=style&index=0&id=18633864&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18633864",
  null
  
)

export default component.exports